export default {
  downloads: {
    description:
      "Nützliche Software für die Diagnose und Programmierung von Brokk-Maschinen.",
    itemName: "Software",
    size: "Größe",
    subtitle: "Software für Brokk-Maschinen herunterladen"
  }
}
